<template>
  <!-- Page Container -->  
    <router-view />
</template>

<script>

export default { 
  name: "App",
}
</script>
